import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/app/contact/pageNew.tsx");
